/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resendemail1Inputs */

const en_resendemail1 = /** @type {(inputs: Resendemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Email`)
};

const de_resendemail1 = /** @type {(inputs: Resendemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail erneut senden`)
};

/**
* | output |
* | --- |
* | "Resend Email" |
*
* @param {Resendemail1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resendemail1 = /** @type {((inputs?: Resendemail1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resendemail1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resendemail1(inputs)
	return de_resendemail1(inputs)
});
export { resendemail1 as "resendEmail" }